"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldGroupFieldName = getFieldGroupFieldName;
const perfParamRegex = /^(.+?)?_(.+?)$/;
function getFieldGroupFieldName(productId, value) {
    const matches = perfParamRegex.exec(
    // resultKey
    value);
    if (!matches) {
        return undefined;
    }
    const [, section, fieldName] = matches;
    const fieldGroup = `PerfParam.${section && section.length > 0 ? section : productId}`;
    return { fieldGroup, fieldName };
}
//# sourceMappingURL=field-group-field-name.js.map